import { MouseEvent } from 'react';
import clsx from 'clsx';

type ClearFilterButtonProps = {
    ariaLabel: string;
    onClick: () => void;
    className?: string;
};

export const ClearFilterButton = ({ ariaLabel, onClick, className }: ClearFilterButtonProps) => {
    const onButtonClick = (event: MouseEvent<HTMLButtonElement>) => {
        event.preventDefault();
        event.stopPropagation();
        onClick();
    };

    return (
        <button
            type="button"
            aria-label={ariaLabel}
            className={clsx(
                'flex h-[34px] w-[34px] shrink-0 items-center justify-center appearance-none border-0 bg-transparent p-0 text-sm leading-none text-slate-400 transition-colors hover:text-slate-700',
                className,
            )}
            onClick={onButtonClick}
        >
            x
        </button>
    );
};
